import { render, staticRenderFns } from "./domainConfig.vue?vue&type=template&id=2cb9b45b&scoped=true&"
import script from "./domainConfig.vue?vue&type=script&lang=js&"
export * from "./domainConfig.vue?vue&type=script&lang=js&"
import style0 from "./domainConfig.vue?vue&type=style&index=0&id=2cb9b45b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9b45b",
  null
  
)

export default component.exports